import React from 'react'

export const isTokenExpired = (token) => {
  try {
    const [, payload] = token.split(".");
    const decoded = JSON.parse(atob(payload));
    if (!decoded.exp) return true; // no expiry -> treat as expired
    return decoded.exp * 1000 < Date.now();
  } catch (err) {
    return true; // invalid token -> expired
  }
};

export const logoutUser = () => {
  localStorage.clear();
  window.location.href = "/login";
};